import React from "react";
import ReactDOM from "react-dom";

import "./index.less";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./fonts/SFProText.ttf";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
// to support RTL
document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
